import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IStore } from '../../store/types'
import { SearchWorkspace } from '../../components/SearchWorkspace'
import { useAppDispatch } from '../../store'
import { searchChats } from '../../store/searchChatsOnline/actions'
import { STATUSES_CHAT } from '../../utils/consts'
import { ROUTES } from '../../utils/routes'

export const SearchChatOnline: React.FC = () => {
  const { searchChatsOnline } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!searchChatsOnline.data) {
      dispatch(searchChats({}))
    }
  }, [searchChatsOnline.data])

  const handleChangePage = (page: number) => {
    if (!searchChatsOnline.data) return null
    if (searchChatsOnline.data.pages >= page) {
      dispatch(searchChats({ ...searchChatsOnline.searchFields, page }))
    }
  }

  const handleGetDialog = (dialogId: number) => {
    navigate(ROUTES.changeSearch(dialogId))
  }

  return (
    <SearchWorkspace
      types={STATUSES_CHAT}
      data={searchChatsOnline.data}
      changePage={handleChangePage}
      getDialog={handleGetDialog}
    />
  )
}
